<template>
  <div>
    <b-form-group
      horizontal
      :label="$t('itemMarkup')"
      label-for="itemMarkup"
      label-class="text-md-right"
      :label-cols="4"
      breakpoint="md"
    >
      <div class="form-control-plaintext">
        {{ formatCurrency(priceCalculation?.itemMarkup) }}
      </div>
      <small class="text-muted">
        {{ $t('price') }} × {{ itemSettings.margin || 0 }}% {{ $t('margin') }}
      </small>
    </b-form-group>

    <b-form-group
      horizontal
      :label="$t('itemCustomerPrice')"
      label-for="itemCustomerPrice"
      label-class="text-md-right"
      :label-cols="4"
      breakpoint="md"
    >
      <div class="form-control-plaintext">
        {{ formatCurrency(priceCalculation?.itemCustomerPrice) }}
      </div>
      <small class="text-muted">
        {{ $t('price') }} + {{ $t('itemMarkup') }} + {{ $t('itemProfitMarkup') }}
      </small>
    </b-form-group>

    <hr />

    <b-form-group
      horizontal
      :label="$t('laborCost')"
      label-for="laborCost"
      label-class="text-md-right"
      :label-cols="4"
      breakpoint="md"
    >
      <div class="form-control-plaintext">
        {{ formatCurrency(priceCalculation?.laborCost) }}
      </div>
      <small class="text-muted">
        {{ $t('installationTimeInMinutes') }} × {{ itemSettings.hourlyRate || 0 }} €/h
        {{ $t('hourlyRate') }}
      </small>
    </b-form-group>

    <hr />

    <b-form-group
      horizontal
      :label="$t('generalBusinessCosts')"
      label-for="generalBusinessCostsMarkup"
      label-class="text-md-right"
      :label-cols="4"
      breakpoint="md"
    >
      <div class="form-control-plaintext">
        {{ formatCurrency(priceCalculation?.generalBusinessCostsMarkup) }}
      </div>
      <small class="text-muted">
        ({{ $t('laborCost') }} + {{ $t('itemCustomerPrice') }}) × {{ itemSettings.generalBusinessCosts || 0 }}%
        {{ $t('generalBusinessCosts') }}
      </small>
    </b-form-group>

    <b-form-group
      horizontal
      :label="$t('profitMargin')"
      label-for="profitMargin"
      label-class="text-md-right"
      :label-cols="4"
      breakpoint="md"
    >
      <div class="form-control-plaintext">
        {{ formatCurrency(priceCalculation?.profitMarkup) }}
      </div>
      <small class="text-muted">
        + {{ itemSettings.profitMargin || 0 }}%
        {{ $t('profitMargin') }}
      </small>
    </b-form-group>

    <b-form-group
      horizontal
      :label="$t('totalCustomerPrice')"
      label-for="totalCustomerPrice"
      label-class="text-md-right font-weight-bold"
      :label-cols="4"
      breakpoint="md"
    >
      <div class="form-control-plaintext font-weight-bold">
        {{ formatCurrency(priceCalculation?.totalCustomerPrice) }}
      </div>
      <small class="text-muted">
      </small>
    </b-form-group>

    <b-form-group
      horizontal
      :label="$t('price') + ' ' + $t('calculatedAt')"
      label-for="calculatedAt"
      label-class="text-md-right"
      :label-cols="4"
      breakpoint="md"
    >
      <div class="form-control-plaintext text-muted">
        {{ formatDateTime(priceCalculation?.calculatedAt) }}
      </div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'ItemPriceCalculation',
  props: {
    priceCalculation: {
      type: Object,
      default: () => ({}),
    },
    itemSettings: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined) return '-';
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatDateTime(dateString) {
      if (!dateString) return '-';
      return new Intl.DateTimeFormat('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(dateString));
    },
  },
};
</script>

<style scoped lang="scss"></style>
